import Swiper from 'swiper';
import { Autoplay } from 'swiper/modules';
import { getSwiperConfig } from '../utils/swiper';

export function handleAnnouncementBar(): void {
  const announcementBar = document.querySelector<HTMLElement>('#announcement-bar');

  if (!announcementBar) return;

  const defaultConfig = {
    slidesPerView: 1,
    modules: [Autoplay],
    speed: 800,
    autoplay: {
      delay: 2000,
      pauseOnMouseEnter: false,
      disableOnInteraction: false
    }
  }
  const config = getSwiperConfig(announcementBar, defaultConfig);

  new Swiper(announcementBar, config);
}
